const t = {
  name: "Rfid",
  dimensions: { width: 40, height: 32 },
  content: `
    <svg fill="currentColor" >
    <g clip-path="url(#clip0_12_4413)">
    <path d="M28 30.0029V13.0029C28 12.4529 27.55 12.0029 27 12.0029H2V29.0029C2 29.5529 2.45 30.0029 3 30.0029H28ZM28.22 32.0029H1.78C0.8 32.0029 0 31.2029 0 30.2229V11.7829C0 10.8029 0.8 10.0029 1.78 10.0029H28.21C29.2 10.0029 30 10.8029 30 11.7829V30.2129C30 31.2029 29.2 32.0029 28.22 32.0029Z" />
    <path d="M39 13.0029C38.45 13.0029 38 12.5529 38 12.0029C38 6.49293 33.51 2.00293 28 2.00293C27.45 2.00293 27 1.55293 27 1.00293C27 0.45293 27.45 0.00292969 28 0.00292969C34.62 0.00292969 40 5.38293 40 12.0029C40 12.5529 39.55 13.0029 39 13.0029Z" />
    <path d="M34 13.0029C33.45 13.0029 33 12.5529 33 12.0029C33 9.24293 30.76 7.00293 28 7.00293C27.45 7.00293 27 6.55293 27 6.00293C27 5.45293 27.45 5.00293 28 5.00293C31.86 5.00293 35 8.14293 35 12.0029C35 12.5529 34.55 13.0029 34 13.0029Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4413">
    <rect width="40" height="32" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>

  `
};
export {
  t as Rfid
};
